import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonBlack, ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import User from '../../images/user-image.png';
import { IoLibraryOutline } from 'react-icons/io5';
import ProgressBarComponent from '../../components/progess_bar'
import { ClockLoader } from 'react-spinners';

function ProfileScreen() {
    const navigate = useNavigate();
    const [cookies] = useCookies();
    const [loadingClasses, setLoadingClasses] = useState(true);
    const [enrolledClasses, setEnrolledClasses] = useState([]);
    const { setTostMessage } = useContext(TostMessageContext);
    const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);
    const [profileData, setProfileData] = useState({ 'f_name': '', 'l_name': '', 'm_name': '', 'streak': '', 'dob': '', 'classes': [], 'attendance': 0, 'dob_raw': '', 'child_id': '' });

    useEffect(() => {
        getClasses();
    }, [])

    const getClasses = async () => {
        setLoadingClasses(true);
        try {
            const response = await axios.get(base_url + '/manage-child/child-profile.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoadingClasses(false);
                setProfileData({'f_name': response.data.results.first_name, 'l_name': response.data.results.last_name, 'm_name': response.data.results.middle_name, 'streak': response.data.results.streak, 'classes': response.data.results.active_classes_enrrolled, 'attendance': response.data.results.attendance, 'dob': response.data.results.dob, 'total_classes_taken': response.data.results.total_classes_taken, 'active_classes': response.data.results.active_classes, 'dob_raw': response.data.results.dob_raw, 'child_id': response.data.results.sub_id });
            } else {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='w-full flex flex-row justify-between'>
                    {loadingClasses ? (
                        <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                            <ClockLoader
                                color={'#F4D00F'}
                                loading={loadingClasses}
                                size={60}
                                aria-label="Loading Spinner"
                                data-testid="loader1"
                            />
                        </div>
                    ) : (
                    <div className="w-full lg:w-[70%] p-0 lg:p-6 space-y-6 min-h-screen">
                        {/* Student Info Card */}
                        <div className="rounded-xl border border-1 border-yellow p-6 flex flex-col md:flex-row justify-start">
                            <div className="w-auto flex flex-col p-4 justify-between items-center">
                                <img src={User} className="h-auto w-[100px] rounded-full border border-1 bg-gray-100" alt="user" />
                                <button onClick={() => navigate('/edit-child', { state: { first_name: profileData?.f_name, last_name: profileData?.l_name, middle_name: profileData?.m_name, dob: profileData?.dob_raw, child_id: profileData?.child_id } })} className="mt-2 px-[2rem] py-[0.5rem] bg-[#241D0C] text-yellow rounded-[5px] text-[12px] font-bold">Edit</button>
                            </div>

                            <div className="flex flex-col w-[-webkit-fill-available] gap-2 text-sm bg-yellow-light p-4 px-6 rounded-[10px]">
                                <div><span className="font-bold">Full Name:</span> {profileData?.f_name} {profileData?.m_name} {profileData?.l_name}</div>
                                <div><span className="font-bold">Date of Birth:</span> {profileData?.dob}</div>
                                <div><span className="font-bold">Languages Taken:</span> {profileData?.total_classes_taken}</div>
                                <div><span className="font-bold">Active Classes:</span> {profileData?.active_classes}</div>
                                {/* <div><span className="font-bold">Tasks Assigned (Attempted):</span> {profileData?.m_name}</div> */}
                            </div>
                        </div>

                        {/* Enrolled Languages & Attendance */}
                        <div className="flex flex-col lg:flex-row h-auto gap-6">
                            <div className="w-full lg:w-[70%] border-yellow rounded-xl border border-1 p-4">
                                <div className="flex justify-between mb-2">
                                    <div className='flex flex-row items-center'>
                                        <IoLibraryOutline />
                                        <h4 className="text-sm ml-2 font-medium text-gray-700">Enrolled Classes</h4>
                                    </div>
                                </div>
                                <div className="flex flex-wrap rounded-[10px] gap-2 bg-yellow-light p-3  w-full">
                                    {profileData?.classes?.map((lang, index) => (
                                        <span
                                        key={index}
                                        className="bg-yellow h-[30px] text-sm px-3 py-1 rounded-[5px] text-gray-800"
                                        >
                                        {lang}
                                        </span>
                                    ))}
                                    {profileData?.classes.length < 1 && (
                                        <span
                                        className="bg-yellow h-[30px] text-sm px-3 py-1 rounded-[5px] text-gray-800"
                                        >
                                        No classes enrolled
                                        </span>
                                    )}
                                </div>
                            </div>
                            
                            <div className="bg-white w-full lg:w-[30%] rounded-xl border border-1 border-yellow p-4 flex flex-col items-center justify-center">
                                <h2 className="text-lg font-semibold mb-2">Attendance</h2>
                                <ProgressBarComponent percentage={profileData?.attendance} />
                                <div className="text-center mt-3 text-[12px] ml-2">
                                    <p className="text-orange font-semibold">{profileData?.streak} Day(s)</p>
                                    <p className="text-orange font-semibold">Streak</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </main>
        </div>
    </div>
  );
}

export default ProfileScreen;
